/* global AFRAME, THREE */

AFRAME.registerComponent('hamburgerbutton', {
  init: function () {
    var self = this;
    var sceneEl = this.el;

    var hamburger = document.getElementById('button-menu');
    hamburger.addEventListener('ended', function () {
      var plane = document.getElementById('mainplane');
      plane.setAttribute('visible', 'true');

      var close = document.getElementById('button-close');
      close.style.display = "none";

      var hamburger = document.getElementById('button-menu');
      hamburger.style.display = "block";

      var logo = document.getElementById('logo');
      logo.style.display = "block";

      var elId = document.getElementById(hamburger.VideoId);
      console.log("hamburger ended: " + elId.id);
      elId.style.display = "none";
      //onlineEl.style.zIndex = 1;

      var hud = document.getElementById('hud');
      hud.style.display = "none";
      clearTimeout(hud.getAttribute('timeout'));

      self.VideoId = -1;
      hamburger.VideoId = -1;

      this.tour = document.querySelector('a-tour');
      var tour = this.tour.components['tour'];
      tour.setHotspots('main');
    });

    self.VideoId = -1;
    hamburger.VideoId = -1;

    // the button of 3 vertical dots
    var button = document.querySelector('#button-menu');
    sceneEl.appendChild(button);

    /*** 2D Videos ***/
    var noite = document.getElementById('el-noite');
    noite.addEventListener('click', function () {
      self.onlineLoadVideo2d('online-noite');
    });

    var compras = document.getElementById('el-compras');
    compras.addEventListener('click', function () {
      self.onlineLoadVideo2d('online-compras');
    });

    var gastro = document.getElementById('el-gastro');
    gastro.addEventListener('click', function () {
      self.onlineLoadVideo2d("online-gastro");
    });

    var hotel = document.getElementById('el-hotel');
    hotel.addEventListener('click', function () {
      self.onlineLoadVideo2d("online-hotel");
    });

    var eventos = document.getElementById('el-eventos');
    eventos.addEventListener('click', function () {
      self.onlineLoadVideo2d("online-eventos");
    });
  },

  onlineLoadVideo2d: function (id) {
    var preloader = document.getElementById('preloader');
    preloader.style.display = "block";

    var hamburger = document.getElementById('button-menu');
    hamburger.style.display = "none";
    
    var logo = document.getElementById('logo');
    logo.style.display = "none";

    self.VideoId = id;
    hamburger.VideoId = id;
    
    // Lazy-load iframe
    var el = document.getElementById(id);
    if (el.getAttribute('src') == "")
      el.setAttribute('src', el.getAttribute('data-src'));

    var player = new Vimeo.Player(id);
    player.ready().then(function() {
      console.log('video is ready');

      var preloader = document.getElementById('preloader');
      preloader.style.display = "none";

      var plane = document.getElementById('mainplane');
      plane.setAttribute('visible', 'false');

      player.play();
    });
    
    player.on('play', function() {
      var close = document.getElementById('button-close');
      close.style.display = "block";

      console.log('player: play ' + self.VideoId);
      var elId = document.getElementById(self.VideoId);

      elId.style.display = "block";
      elId.style.zIndex = 1;
    });

    player.on('loaded', function() {
      console.log('player: loaded ' + self.VideoId);
    });

    player.on('end', function() {
      console.log('player: end');
    });

    this.tour = document.querySelector('a-tour');
    var tour = this.tour.components['tour'];
    tour.setHotspots('unknown-whateverid');
  },
});
